/**
 * Create Aggregate Handler
 * 
 * CQRS Command Handler that delegates to AggregateCommandService.
 * Thin adapter layer that transforms commands to application service calls.
 */

import { injectable, inject } from 'inversify';
import { DDD_SYMBOLS } from '../../../../infrastructure/di/DDD_SYMBOLS';
import { ICommandHandler } from '@swoft/core';
import { CreateAggregateCommand } from '../commands/CreateAggregateCommand';
import { AggregateCommandService } from '../services/AggregateCommandService';

@injectable()
export class CreateAggregateHandler implements ICommandHandler<CreateAggregateCommand, { aggregateId: string }> {
  constructor(
    @inject(DDD_SYMBOLS.AggregateCommandService) private aggregateCommandService: AggregateCommandService
  ) {}

  async handle(command: CreateAggregateCommand): Promise<{ aggregateId: string }> {
    const result = await this.aggregateCommandService.createAggregate(command.payload);
    
    return { 
      aggregateId: result.aggregateId 
    };
  }
}